module.exports = __WEBPACK_EXTERNAL_MODULE__0__;


// WEBPACK FOOTER //
// webpack:///external {"root":"jQuery","commonjs2":"jquery","commonjs":"jquery","amd":"jquery"}